import * as React from "react";
import usePluginEntities from "hooks/usePluginEntities";
const HeaderElements = () => {
  const headerElements = usePluginEntities("views.elements.header");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, headerElements.map((Component, idx) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ React.createElement(Component, { key: idx })
  )));
};
export default HeaderElements;
